import { render, staticRenderFns } from "./PropertyEditor.vue?vue&type=template&id=4a64dd4e&scoped=true"
import script from "./PropertyEditor.vue?vue&type=script&lang=js"
export * from "./PropertyEditor.vue?vue&type=script&lang=js"
import style0 from "./PropertyEditor.vue?vue&type=style&index=0&id=4a64dd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64dd4e",
  null
  
)

export default component.exports